import { render, staticRenderFns } from "./VerticalNavigation.vue?vue&type=template&id=6ec7df04&scoped=true&"
import script from "./VerticalNavigation.vue?vue&type=script&lang=js&"
export * from "./VerticalNavigation.vue?vue&type=script&lang=js&"
import style0 from "./VerticalNavigation.vue?vue&type=style&index=0&id=6ec7df04&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7df04",
  null
  
)

export default component.exports